
// es6
import * as THREE from 'three'

function SkinnedBinLoader(manager) {
    THREE.Loader.call( this, manager );
    this.materials = null;
}

SkinnedBinLoader.prototype = Object.assign(Object.create(THREE.Loader.prototype), {
    constructor: SkinnedBinLoader,
    load: function (url, onLoad, onProgress, onError) {
        const scope = this;
        let loader = new THREE.FileLoader(scope.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.load(url, function (buffer) {
            if (buffer.byteLength === 0) {
                if (onError) onError();
                else return Promise.reject("empty buffer");
                return;
            }
            console.log("buffer", buffer);
            const view = new DataView(buffer);
            let index = 80; // 跳过前80个字符
            let n_vertices = view.getInt32(index, true); // 顶点数量
            index += 4;
            let n_faces = view.getInt32(index, true); // 面数量
            index += 4;
            let n_bones = view.getInt32(index, true); // 骨骼点数量
            index += 4;
            let vertices = new Float32Array(buffer, index, n_vertices * 3); // 顶点数组
            index += n_vertices * 3 * 4;
            // 面数组：需要转换为普通数组
            let indices = Array.from(new Int32Array(buffer, index, n_faces * 3));
            index += n_faces * 3 * 4;
            // 骨骼点
            let bonePositions = new Float32Array(buffer, index, n_bones * 3);
            index += n_bones * 3 * 4;
            let bones = [];
            for (let i = 0; i < n_bones; i++) {
                let bone = new THREE.Bone();
                bone.position.set(bonePositions[i * 3],
                    bonePositions[i * 3 + 1],
                    bonePositions[i * 3 + 2]);
                bones.push(bone);
            }
            let skeleton = new THREE.Skeleton(bones);
            // 所有点的骨骼点的下标
            let skinIndices = new Uint16Array(buffer, index, n_vertices * 4);
            index += n_vertices * 4 * 2;
            // 所有点的骨骼点的权重
            let skinWeights = new Float32Array(buffer, index, n_vertices * 4);
            index += n_vertices * 4 * 4;

            let geom = new THREE.BufferGeometry();
            geom.setAttribute("position", new THREE.BufferAttribute(vertices, 3));
            geom.setIndex(indices);
            geom.setAttribute('skinIndex', new THREE.Uint16BufferAttribute(skinIndices, 4));
            geom.setAttribute('skinWeight', new THREE.Float32BufferAttribute(skinWeights, 4));
            console.log("geom", geom);
            geom.computeVertexNormals();

            onLoad(geom, skeleton);
        }, onProgress, onError);
    }
});

export default SkinnedBinLoader;



// WEBPACK FOOTER //
// ./src/views/headPortrait3d/scripts/SkinnedBinLoader.js